import React, { useEffect, useRef, useState } from 'react';
import styles from "../../page/css/Exhibition.module.css";
import { Chip, TextField } from "@mui/material";
import { Add, DragHandle, Remove, Edit } from "@mui/icons-material";
import Box from "../inputs/Box";
import Swal from "sweetalert2";

import { useDispatch, useSelector } from "react-redux";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { setSequence } from "service/util/setSequence";
import { exhibitionActions } from "reducers/exhibition";

const ExhibitionFormSubTopic = ({ create, edit }) => {
    const dispatch = useDispatch();
    const nextSeq = useRef(0);
    const titleRef = useRef([]);
    const [subTopicListDnd, setSubTopicListDnd] = useState([]);
    // const [newText, setNewText] = useState("");
    const type = useSelector(state => state.exhibitionData.type);
    const subTopic = useSelector(state => state.exhibitionData.subTopic);
    const subTopicList = useSelector(state => state.exhibitionData.subTopicList);

    const { title } = subTopic;

    useEffect(() => {
        setSubTopicListDnd([]);
    }, [])

    useEffect(() => {
        if (edit) {
            setSubTopicListDnd(subTopicList);
        }
    }, [edit, subTopicList])

    useEffect(() => {
        dispatch(exhibitionActions.setSubTopicList(subTopicListDnd));
    }, [subTopicListDnd, dispatch])


    const onChangeSubTopics = (e) => {
        const { name, value } = e.currentTarget;
        dispatch(exhibitionActions.setSubTopic({
            ...subTopic,
            [name]: value
        }))
    }
    const onCreate = () => {
        if (edit) {
            let arr = [];
            arr.push(subTopicListDnd.map(topic => topic.seq));
            if (arr[0].length >= 1) {
                nextSeq.current = Math.max.apply(null, arr[0]);
            }
        }
        nextSeq.current += 1;
        const data = {
            id: null,
            seq: nextSeq.current,
            title,
        };
        if (title === "") {
            Swal.fire({
                title: '타이틀을 입력해주세요.',
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) return false; });
        } else {
            setSubTopicListDnd([...subTopicListDnd, data]);
        }
        dispatch(exhibitionActions.setSubTopic({ title: "" }))
    }

    const onRemoveSubTopic = (e, seq) => {
        e.preventDefault();
        const listBySeq = subTopicListDnd.filter(item => item.seq !== seq);
        setSubTopicListDnd(listBySeq);
        return true;
    }
    const onChangeSubTopic = (e, seq) => {
        // setNewText(e.currentTarget.value);
        setSubTopicListDnd(subTopicListDnd.map(topic => topic.seq === seq ? {...topic, title: e.target.value} : topic));
    }

    // const onEditSubTopic = (e, id) => {
    //     e.preventDefault();
    //     if (newText !== '') {
    //         console.log(newText);
    //         if (edit) {
    //             setSubTopicListDnd(subTopicListDnd.map(topic => topic.id === id ? {...topic, title: newText} : topic));
    //         } else {
    //             setSubTopicListDnd(subTopicListDnd.map(topic => topic.seq === id ? {...topic, title: newText} : topic));
    //         }
    //         Swal.fire({
    //             text: "수정이 완료되었습니다",
    //             icon: 'success',
    //             confirmButtonText: '확인',
    //         }).then(result => {
    //             if (result.value) return true;
    //         });
    //     }
    // }

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        setSubTopicListDnd((item) => setSequence(item, result.source.index, result.destination.index));
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onCreate();
        }
    }
    return (
        <Box className={styles.exhContainer}>
            <h3>중제목 정보</h3>
            <div style={{ width: "400px", margin: "0 auto" }}>
                <Chip label="중제목 타이틀" sx={{ marginBottom: "0.8rem", lineHeight: "32px", display: "inline-block", }} />
                <label className={styles.exhLabel} style={{ margin: "0 auto", }}>
                    <div style={{ margin: "0 auto", display: "flex" }}>
                        <TextField
                            className={`${styles.textInput} ${styles.subTextInput}`}
                            type={"text"}
                            value={title}
                            onKeyDown={(e) => onKeyDown(e)}
                            onChange={onChangeSubTopics}
                            label={type === "kor" ? "한글로 입력해 주세요(특수문자 입력 불가) " : "영문으로 입력해 주세요(특수문자 입력 불가) "} name={"title"} variant="outlined" size="small"
                        />
                        <button className={styles.iconBtn} type={"button"} onClick={onCreate}><Add /></button>
                    </div>
                </label>
            </div>
            <Box style={{ marginTop: "1rem" }}>
                {subTopicListDnd.length === 0 &&  <p className={"noData"} style={{ textAlign: "center", padding: "3rem 0" }}>데이터가 없습니다. 등록해주세요.</p>}
                {subTopicListDnd.length >= 1 && (
                    <>
                    <span className={"caption"} style={{ display: "flex", alignItems: "center" }}>* 수정을 원하시면 <Edit sx={{ color: "#a2b521", margin: "0 0.5rem" }} /> 버튼을 눌러주세요.</span>
                        <ul className={styles.subTopicList}>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId={"subTopicListForm"}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {subTopicListDnd.map((sub, index) => {
                                                return (
                                                    <Draggable key={"subTopicListForm" + index} draggableId={"subTopicListForm" + index} index={index}>
                                                        {provided => (
                                                            <li style={{ marginBottom: "1rem" }}
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <DragHandle sx={{ marginRight: '1rem' }} color={"action"} />
                                                                <TextField
                                                                    inputRef={el => (titleRef.current[sub.seq] = el)}
                                                                    value={sub.title ? sub.title || '' : ''}
                                                                    className={`${styles.textInput} ${styles.subTextInput}`}
                                                                    onChange={(e) => onChangeSubTopic(e, sub.seq)}
                                                                    name={"subTitle"}
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                                <button className={`${styles.iconBtn} ${styles.removeBtn}`} onClick={(e) => onRemoveSubTopic(e, sub.seq)}><Remove /></button>
                                                                {/*<button className={`${styles.iconBtn} ${styles.editBtn}`} onClick={(e) => onEditSubTopic(e, sub.seq)}><Edit /></button>*/}
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                )
                                            })}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </ul>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default ExhibitionFormSubTopic;